import { useQuery } from '@tanstack/react-query';
import { accountApi } from '../services/accountApi';

/**
 * Hook to fetch current authenticated user data
 */
export const useCurrentUser = () => {
  return useQuery({
    queryKey: ['current-user'],
    queryFn: ({ signal }) => accountApi.getCurrentUser(signal),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
